<header class="page-header stack" [class.page-header--compact]="isCompact()">
  @if (!isCompact()) {
    <ng-container [ngTemplateOutlet]="backButton" />
  }

  <div class="page-header__row">
    @if (isCompact()) {
      <ng-container [ngTemplateOutlet]="backButton" />
    }

    <div class="page-header__heading stack">
      @if (headingLevel() === 1) {
        <h1 id="pageTitle" tabindex="-1" class="heading-1 heading-flush route-focus-target page-header__title text-truncate">
          <span [skeletonInline]="isFirstLoad()" skeletonWidth="220px">{{ heading() }}</span>
        </h1>
      } @else {
        <h2 class="heading-2 heading-flush page-header__title text-truncate">
          <span [skeletonInline]="isFirstLoad()" skeletonWidth="220px">{{ heading() }}</span>
        </h2>
      }
      @if (subtitle(); as text) {
        <p class="page-header__subtitle mat-text-on-surface-variant">{{ text }}</p>
      }
    </div>

    <div class="page-actions">
      <ng-content />
    </div>
  </div>
</header>

<ng-template #backButton>
  @if (backLink(); as link) {
    <a matButton class="page-header__back app-button-flush" [routerLink]="link">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      {{ backLabel() }}
    </a>
  }
</ng-template>
